import { ISort } from '@/components/table/types';
import { Dispatch, SetStateAction } from 'react';
import styled from 'styled-components';
import FooterModal from '../../../footer';
import { ProgressBar } from '../../../progressBar';
import { Status } from '../../../status';
import { ImportWrapper } from '../../../styles';
import { investorEntitiesSteps } from '../../constants';
import { IEntityImportComparison, IEntityResponse, ImportInvestorEntitiesUpdateMethodOptionEnum, TypeWindow } from '../../types';
import { investorEntitiesStatusError, investorEntitiesStatusSuccess } from './constants';
import Table from './table/table';

interface InvestorEntitiesProps {
  importSteps: typeof investorEntitiesSteps;
  prevStep: () => void;
  nextStep: () => void;
  entityData: IEntityResponse | null;
  updateMethod: ImportInvestorEntitiesUpdateMethodOptionEnum;
  errors: IEntityImportComparison[];
  sort: ISort;
  setSort: Dispatch<SetStateAction<ISort>>;
  search: string;
  onChangeSearch: (value: string) => void;
  primaryFilter: string;
  showTable: boolean;
  setShowTable: Dispatch<SetStateAction<boolean>>;
  changePrimaryFilterValue: (filter: string) => void;
  openEntityImportDetailPage: (type: TypeWindow, row: IEntityImportComparison) => void;
}

export const InvestorEntities = ({
  importSteps,
  prevStep,
  nextStep,
  entityData,
  updateMethod,
  errors,
  sort,
  setSort,
  search,
  onChangeSearch,
  primaryFilter,
  showTable,
  setShowTable,
  changePrimaryFilterValue,
  openEntityImportDetailPage
}: InvestorEntitiesProps) => {
  if (!entityData) {
    return <></>;
  }

  return (
    <>
      <ImportWrapper>
        <ProgressBar importSteps={importSteps} />
        <Status
          errorsCount={errors.length || null}
          matched={[
            { count: entityData.newEntitiesCount, text: 'New Entities' },
            { count: entityData.updatedEntitiesCount, text: 'Updated Entities' },
            { count: entityData.unchangedEntitiesCount, text: 'Unchanged Entities' }
          ]}
          showTable={showTable}
          setShowTable={setShowTable}
          startOver={prevStep}
          confirmButton={{ name: 'Continue', onClick: nextStep, disabled: Boolean(errors.length) }}
          success={{ ...investorEntitiesStatusSuccess, viewAll: primaryFilter === 'Updates Only' ? 'View All Updates' : 'View All' }}
          error={investorEntitiesStatusError}
        />
      </ImportWrapper>
      {showTable || errors?.length ? (
        <TableWrapper>
          <Table
            tableData={entityData.entityImportComparisons}
            updateMethod={updateMethod}
            openEntityImportDetailPage={openEntityImportDetailPage}
            sort={sort}
            setSort={setSort}
            search={search}
            onChangeSearch={onChangeSearch}
            primaryFilter={primaryFilter}
            changePrimaryFilterValue={changePrimaryFilterValue}
          />
        </TableWrapper>
      ) : (
        <></>
      )}
      {errors?.length || showTable ? (
        <FooterModal
          startOver={prevStep}
          startOverButtonName="Back"
          confirmButton={{ name: 'Continue', onClick: nextStep, disabled: Boolean(errors.length) }}
        />
      ) : (
        <></>
      )}
    </>
  );
};

const TableWrapper = styled.div`
  margin-bottom: 100px;
`;
